<template>
  <div class="content-section" v-loading.fullscreen.lock="fullscreenLoading">
    <h2 class="page-title">子账号管理</h2>

    <div >
      <el-form :inline="true" :model="queryParams" class="demo-form-inline">
        <el-form-item label="名称">
          <el-input v-model="queryParams.keyWord" placeholder="关键字"></el-input>
        </el-form-item>
        <el-form-item>
          <button class="btn btn-primary" @click.prevent="loadData">查询</button>
          <button class="btn btn-success" @click="addSub">添加子账号</button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <el-table
        :data="subAccounts"
        height="500"
        v-loading="tableLoading"
        border
        style="width: 100%">

        <el-table-column
          prop="F_UserName"
          label="用户名"
          align="center"
          header-align="center"
         >
        </el-table-column>
        <!--<el-table-column-->
          <!--prop="F_UserPwd"-->
          <!--align="center"-->
          <!--header-align="center"-->

          <!--label="密码">-->

        <!--</el-table-column>-->
        <el-table-column
          prop="F_Phone"
          align="center"
          header-align="center"

          label="手机号">
        </el-table-column>
        <el-table-column
          prop="F_Status"
          align="center"
          header-align="center"

          label="状态">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.F_Status == 1" size="medium">启用</el-tag>
            <el-tag v-else-if="scope.row.F_Status == 2" size="medium" type="danger">禁用</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          header-align="center"
          width="200"
          fixed="right"
          label="操作">
          <template slot-scope="scope">
            <button class="btn btn-sm btn-primary" @click="onReset(scope.row)">重置密码</button>
            <button class="btn btn-sm btn-success" @click="onEdit(scope.row)">编辑</button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="PageSize"
        @current-change="onCurrentChange"
        @size-change="onSizeChange"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog v-loading="loadingFull"
               element-loading-text="拼命加载中"
               element-loading-spinner="el-icon-loading"
               element-loading-background="rgba(0, 0, 0, 0.8)" center title="子账号信息" :visible.sync="comInfoVisible" @open="handleDialogOpen" :close-on-click-modal="false">
      <el-form :model="form" ref="formYY" :rules="rules" label-position="left" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="用户名" prop="F_UserName">
              <el-input  v-model="form.F_UserName" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="!canEdit" :span="12">
            <el-form-item label="密码" prop="F_UserPwd">
              <el-input type="password" v-model="form.F_UserPwd" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="手机号" prop="F_Phone">
              <el-input v-model="form.F_Phone" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" prop="F_Status">
              <el-select style="width: 100%;" v-model="form.F_Status" placeholder="请选择">
                <el-option
                  v-for="(item,index) in optionsBooler"
                  :key="index"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="success" plain @click="saveAccount">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      function validatePhoneOrTel(rule,value,callback) {
        let regex = /^(\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$/;

        if (value != null && !regex.test(value)) {
          callback(new Error("请输入正确的电话号码"));
        } else {
          callback();
        }
      }
      return {
        queryParams:{
          keyWord:''
        },
        optionsBooler:[
          {label:'启用',value:1},{label:'禁用',value:2}
        ],
        url: {
          list: SZH.assets.api + '/Custom/GetPagingAcountChilren',
          GetCustomAcountChild: SZH.assets.api + '/Custom/GetCustomAcountChild',
          SaveAccountChildInfo: SZH.assets.api + '/Custom/SaveAccountChildInfo',
          AcountChildRevisePassword: SZH.assets.api + '/Custom/AcountChildRevisePassword',
        },
        tableLoading:false,
        comInfoVisible:false,
        loadingFull:false,
        fullscreenLoading:false,
        canEdit:false,
        subAccounts: [],
        PageIndex:1,
        PageSize:50,
        total:0,
        form:{
          F_Id:'',//,主键
          F_UserName:'',//,用户名
          F_UserPwd:'',//,密码
          F_Phone:'',//,手机号
          F_Status:'',//,状态 1启用 2禁用
        },
        rules:{
          F_UserName: [
            {required: true,message: "请输入用户名",trigger: "blur"},
            {
              min: 6,
              max: 25,
              message: '用户名长度应在 6 到 25 个字符之间',
              trigger: 'blur'
            },
            {
              validator: validateUsername,
              trigger: 'blur'
            }
          ],
          F_UserPwd: [
            {required: true,message: "请输入密码",trigger: "blur"},
            {
              validator: validatePassword,
              trigger: 'blur'
            }
          ],
          F_Phone: [
            {required: true,message: "请输入手机号",trigger: "blur"},
            {
              validator: validatePhoneOrTel,
              trigger: "blur",
            },
          ],
          F_Status: [
            {required: true,message: "请选择状态",trigger: "change"},
          ],
        },
      }
    },
    methods: {
      onEdit(row){
        let self = this;
        self.canEdit = true;
        self.comInfoVisible = true;
        self.loadingFull = true;
        self.$http.post(self.url.GetCustomAcountChild, {
          keyValue:row.F_Id,
        }).then(result => {
          if (result.state == 1) {
            for(let i in self.form){
              self.form[i] = result.data[i]
            }
            self.loadingFull = false;
          } else {
            self.loadingFull = false;
            self.$message.error(result.message);
          }
        }, () => {
          self.$message.error("数据加载失败，请检查您的网络是否可用。");
        });
      },
      onReset(row){
        let self = this;
        self.$prompt('请输入新密码', '重置密码', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center:true,
          inputPattern: /^.*(?=.{8,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z]).*$/,
          inputErrorMessage: '请输入新密码'
        }).then(({ value }) => {
          self.fullscreenLoading = true;
          self.$http.post(self.url.AcountChildRevisePassword, {
            keyValue:row.F_Id,
            pwd:value
          }).then(result => {
            if (result.state == 1) {
              self.fullscreenLoading = false;
              self.$message.success("操作成功");
              self.loadData();
            } else {
              self.fullscreenLoading = false;
              self.$message.error(result.message);
            }
          }, () => {
            self.$message.error("数据加载失败，请检查您的网络是否可用。");
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      },
      onSizeChange(val) {
        this.PageSize = val;
        this.loadData();
      },
      onCurrentChange(val) {
        this.PageIndex = val;
        this.loadData();
      },
      handleDialogOpen(){
        this.$nextTick(()=>{
          this.$refs['formYY'].resetFields();
        });
      },
      addSub(){
        let self = this;
        self.canEdit = false;
        self.comInfoVisible = true;
      },
      saveAccount(){
        let self = this;
        self.$refs['formYY'].validate((valid) => {
          if (valid) {
            self.loadingFull = true;
            self.$http.post(self.url.SaveAccountChildInfo,self.form)
              .then(result => {
                if (result.state == true) {
                  self.$message.success('保存成功');
                  self.loadingFull = false;
                  self.comInfoVisible = false;
                  self.loadData();
                } else {
                  self.loadingFull = false;
                  self.$message.error(result.message);
                }
              }, () => {
                self.loadingFull = false;
                // 请求失败
                self.$message.error('登录失败，请检查您的网络是否可用。');
              });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      loadData(){
        let self = this;
        self.tableLoading = true;
        self.$http.post(self.url.list,{
          Data:self.queryParams,
          PageIndex:self.PageIndex,
          PageSize:self.PageSize
        })
          .then(result => {
            if (result.state == true && result.data && result.data.Data && result.data.Data.length>0) {
              self.subAccounts = result.data.Data;
              self.total = result.data.TotalCount;
              self.tableLoading = false;
            } else {
              self.subAccounts = [];
              self.total = 0;
              self.tableLoading = false;
              self.$message.error(result.message);
            }

          }, () => {
            self.tableLoading = false;
            // 请求失败
            self.$message.error('登录失败，请检查您的网络是否可用。');
          });
      },
    },
    computed: {},
    components: {
    },
    mounted() {
      this.loadData()
    }
  }
</script>

<style scoped>
  .subaccount-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Me/SubAccountManagement/SubAccountManagement.vue